export const invert = value => value * -1;
